<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { ServerForm } from '~/types/servers'

const { t } = useI18n()
const dialogRef = inject('dialogRef') as any
const serversStore = useServersStore()

async function handleSubmit(formData: ServerForm): Promise<void> {
  const success = await serversStore.createServer(formData)
  if (success) {
    dialogRef.value?.close()
  }
}
</script>

<template>
  
<FormKitLazyProvider config-file="true">
<FormKit
    id="server-create-form"
    class="flex"
    type="form"
    :actions="false"
    @submit="handleSubmit"
  >
    <div class="flex gap-3 justify-center">
      <div class="w-1/2">
        <FormKit
          type="text"
          :label="t('Name')"
          :placeholder="t('Maria Garcia')"
          validation="required"
          validation-visibility="live"
          name="name"
        />
        <FormKit
          type="text"
          :label="t('PIN Code')"
          :placeholder="t('4-6 digit PIN')"
          validation="required|number|length:4,6"
          :validation-messages="{
            number: t('PIN must contain only digits'),
            length: t('PIN must be 4-6 digits'),
          }"
          validation-visibility="live"
          name="pin_code"
          inputmode="numeric"
        />
        <FormKit
          type="text"
          :label="t('Employee Number')"
          :placeholder="t('Optional')"
          name="employee_number"
        />
        <FormKit
          type="checkbox"
          :label="t('Handles To-Go Orders')"
          name="handles_togo"
          :value="false"
        />
        <FormKit
          type="checkbox"
          :label="t('Handles Delivery Orders')"
          name="handles_delivery"
          :value="false"
        />
        <FormKit
          type="checkbox"
          :label="t('Active')"
          name="active"
          :value="true"
        />
        <FormKit
          type="submit"
          :label="t('Add server')"
        />
      </div>
    </div>
  </FormKit>
</FormKitLazyProvider>

</template>
